import { render, staticRenderFns } from "./FloatingButtonsDealer.vue?vue&type=template&id=54ec93a1&scoped=true"
import script from "./FloatingButtonsDealer.vue?vue&type=script&lang=js"
export * from "./FloatingButtonsDealer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ec93a1",
  null
  
)

export default component.exports